import {
  Box,
  Paper, Typography, useTheme,  
  FormControl,
  Select,
  MenuItem,    
  InputLabel,  
  Tooltip,
  Autocomplete,
  CircularProgress,
  TextField,
  Card,
  CardActionArea,
  CardMedia,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
//import { ptBR } from '@mui/x-data-grid/locales';
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, TDropOptions, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { Loading } from "../../shered/components/loading/Loading";
import { GridSaveAltIcon } from "@mui/x-data-grid";
import { LoadingButton } from "@mui/lab";
import { IDadosComparacao, IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { GraficoBarrasHorizontalRight } from "../../shered/components/charts/GraficoBarrasHorizontalRight";
import { GraficoBarrasHorizontalLeft } from "../../shered/components/charts/GraficoBarrasHorizontalLeft";

export const ListagemDeComparacaoJogadores: React.FC = () => {
  const theme = useTheme();
  const { themeName } = useAppThemeContext();
  const refTab = useRef<any>(null);
  const { debounce } = useDebounce();
  const [isLoading, setIsLoading] = useState(true);
  const [removeLoading, setRemoveLoading] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuthContext();
  const user = CookieService.get("access_user");
  let codLocal = localStorage.getItem("@codigoLiga");
  const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
  const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../../semimagemescudo.png");
  const [semImagemFranquia] = useState<any>("../../../semimagemescudo.png");
  const [versusImg] = useState<any>("../../versus.png");
  const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
  const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
  const [showModalMensagem, setShowModalMensagem] = useState(false);
  const [redirecionar, setRedirecionar] = useState("");
  const [searchParams, SetSearchParams] = useSearchParams();
  const [temporadaFiltro, setTemporadaFiltro] = useState(0);
  const [tipoFiltro, setTipoFiltro] = useState(1);
  // const [codigoJogadorFiltro1, setCodigoJogadorFiltro1] = useState(0);
  // const [codigoJogadorFiltro2, setCodigoJogadorFiltro2] = useState(0);
  const [imagemTrofelConferencia] = useState<any | null>("../../../newConferencia.png");
  const [imagemTrofelDivisao] = useState<any | null>("../../../newDivisao.png");
  const [imagemTrofelLiga] = useState<any | null>("../../../newLiga.png");
  const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
  const [dadosJogador1, setDadosJogador1] = useState<IDadosComparacao>();
  const [dadosJogador2, setDadosJogador2] = useState<IDadosComparacao>();
  const [lstJogadores, setLstJogadores] = useState<ILstDrop[]>([]);
  const [opcoesAutoCompleteJogador1, setOpcoesAutoCompleteJogador1] = useState<TDropOptions[]>([])
  const [opcoesAutoCompleteJogador2, setOpcoesAutoCompleteJogador2] = useState<TDropOptions[]>([])
  const [rowsJogadores, setRowsJogadores] = useState<IListagemJogador[]>([]);
  const [selectedIdComplete1, setSelectedIdComplete1] = useState<number | undefined>(0);
  const [selectedIdComplete2, setSelectedIdComplete2] = useState<number | undefined>(0);

  //const [meusJogadoresRows, setMeusJogadoresRows] = useState<IListagemMeusJogadores[]>([]);
  const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
    acao: false,
    label: "",
    tipo: "error",
    mensagem: "Sessão Expirada!",
    display: "none",
    titulo: "Atenção"
  });

  const [showModalEvent, setShowModalEvent] = useState(false);
  const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
    acao: false,
    label: "",
    tipo: "info",
    mensagem: "Deseja ronovar com o jogador ",
    display: "none",
    titulo: "Atenção"
  });

  useEffect(() => {
    setIsLoading(true);
    if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
      setShowModalMensagem(true);
      setDadosModalMensagem({
        acao: true,
        label: "",
        tipo: "warning",
        mensagem: "Favor selecionar uma liga!",
        display: "none",
        titulo: "Atenção"
      });
      setRedirecionar("/dashboard");
      return;
    } else {
      debounce(() => {
        UtilidadeService.getTemporadasLigaPorTipoQtd(Number(codigoLiga), 1, 4, 0)
          .then((result) => {
            const tmps = result.data.dado;
            let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
            setLstTemporadas(lstTemporadasAux);
          })
          .catch((errors) => {
            setShowModalMensagem(true);
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
          });

        LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
          .then((result) => {
            const liga = result.dado;
            setDadosLiga(liga);
            if (liga.caminho_Logo !== null) {
              setShowImagemFranquia(liga.caminho_Logo);
            }
            setTemporadaFiltro(liga.codigo_Temporada);
          })
          .catch((errors) => {
            setShowModalMensagem(true);
            setRemoveLoading(true);
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
          });

        JogadorService.getTodosJogadores(Number(codigoLiga), selectedIdComplete1)
          .then(result => {
            setRowsJogadores(result.data.dado);
            const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
              .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
            setOpcoesAutoCompleteJogador1(lstDrop);
          }).catch((errors) => {
            setIsLoading(false);
            setShowModalMensagem(true);
            if (errors.response.data.statusHTTP === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: "Sessão Expirada! 1",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }
            if (errors.response.data.mensagem !== undefined) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
            }
            else {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
                display: "none",
                titulo: "Atenção"
              });
            }
          });

        JogadorService.getTodosJogadores(Number(codigoLiga), selectedIdComplete2)
          .then(result => {
            setRowsJogadores(result.data.dado);
            const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
              .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
            setOpcoesAutoCompleteJogador2(lstDrop);
          }).catch((errors) => {
            setIsLoading(false);
            setShowModalMensagem(true);
            if (errors.response.data.statusHTTP === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: "Sessão Expirada! 1",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }
            if (errors.response.data.mensagem !== undefined) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
            }
            else {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
                display: "none",
                titulo: "Atenção"
              });
            }
          });

        setIsLoading(false);
      })
    }
  }, []);

  const autoCompleteSelectedOption1 = useMemo(() => {
    if (!selectedIdComplete1) return null;

    const selectedOption = opcoesAutoCompleteJogador1.find(opcao => opcao.codigo === selectedIdComplete1);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedIdComplete1, opcoesAutoCompleteJogador1]);

  const autoCompleteSelectedOption2 = useMemo(() => {
    if (!selectedIdComplete2) return null;

    const selectedOption = opcoesAutoCompleteJogador2.find(opcao => opcao.codigo === selectedIdComplete2);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedIdComplete2, opcoesAutoCompleteJogador2]);

  const carregarDadosMediasJogador1 = (codigoJogador: number, codigoLiga: number, codigoTemporada: number, tipo: number) => {
    setIsLoading(true);
    setRemoveLoading(false);
    setTipoFiltro(tipo);
    JogadorService.getJogadorComparacaoPorCodigo(codigoJogador, codigoLiga, codigoTemporada)
      .then((result) => {
        const lstDados = result.dado;      
        setDadosJogador1(lstDados);
        setIsLoading(false);
        setRemoveLoading(true);
      })
      .catch((errors) => {
        setShowModalMensagem(true);
        setRemoveLoading(true);
        if (errors.response) {
          if (errors.response.status === 401) {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "info",
              mensagem: "Sessão expirada!",
              display: "none",
              titulo: "Atenção"
            });
            logout();
            setRedirecionar("0");
            return;
          }

          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: errors.response.data.mensagem,
            display: "none",
            titulo: "Atenção"
          });
          return;
        }

        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "error",
          mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
          display: "none",
          titulo: "Atenção"
        });

        setRedirecionar(`/usuario/liga/${codLocal}`);
        return;
      });


  }

  const carregarDadosMediasJogador2 = (codigoJogador: number, codigoLiga: number, codigoTemporada: number, tipo: number) => {
    setIsLoading(true);
    setRemoveLoading(false);
    setTipoFiltro(tipo);
    JogadorService.getJogadorComparacaoPorCodigo(codigoJogador, codigoLiga, codigoTemporada)
      .then((result) => {
        const lstDados = result.dado;
        setDadosJogador2(lstDados);

        setIsLoading(false);
        setRemoveLoading(true);
      })
      .catch((errors) => {
        setShowModalMensagem(true);
        setRemoveLoading(true);
        if (errors.response) {
          if (errors.response.status === 401) {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "info",
              mensagem: "Sessão expirada!",
              display: "none",
              titulo: "Atenção"
            });
            logout();
            setRedirecionar("0");
            return;
          }

          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: errors.response.data.mensagem,
            display: "none",
            titulo: "Atenção"
          });
          return;
        }

        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "error",
          mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
          display: "none",
          titulo: "Atenção"
        });

        setRedirecionar(`/usuario/liga/${codLocal}`);
        return;
      });


  }


  const toggleModalMensagem = () => {
    setShowModalMensagem(modalVisivel => !modalVisivel);
    if (redirecionar !== "") {
      redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    }
  };

  const toggleModalEvent = () => {
    setShowModalEvent(modalVisivel => !modalVisivel);
    if (redirecionar !== "") {
      redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    }
  }



  const handleCarregar = async () => {

    if (selectedIdComplete1 !== undefined && selectedIdComplete1 > 0) {

      carregarDadosMediasJogador1(selectedIdComplete1, Number(codigoLiga), Number(temporadaFiltro), 1);
    }
    if (selectedIdComplete2 !== undefined && selectedIdComplete2 > 0) {

      carregarDadosMediasJogador2(selectedIdComplete2, Number(codigoLiga), Number(temporadaFiltro), 2);
    }

  }


  return (
    <LayoutBaseDePagina
      titulo={`Comparação Jogadores - ${dadosLiga?.nome}`}
      showLogoImg={showImagemFranquia}
      barraDeFerramentas={<FerramentasDaListagem
        textoBotaoNovo="Nova"
        mostrarBotaoNovo={false}
        mostrarInputBusca={false}
        aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
      />}>

      {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
      {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
      <Box margin={1} display="flex" component={Paper} variant="outlined" >
        <Grid container size={{ xs: 12, sm: 12 }} padding={UtilidadeService.isMobile() ? 1 : 2} spacing={UtilidadeService.isMobile() ? 1 : 2}>

          <Grid size={{ xs: 12, sm: 12 }}>
            <Typography variant="h6"> Comparação dos Jogadores </Typography>
            <hr />
          </Grid>
          <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" sx={{ width: "100%" }}>
            <Grid size={{ xs: 12, sm: 3, md: 3 }} paddingBottom={2}>
              <Autocomplete
                openText="Abrir"
                closeText="Fechar"
                noOptionsText="Sem opções"
                loadingText="Carregando..."
                options={opcoesAutoCompleteJogador1}
                loading={isLoading}
                disabled={isLoading}
                value={autoCompleteSelectedOption1}
                size={UtilidadeService.isMobile() ? "small" : "medium"}
                onChange={(event, newValue) => { setSelectedIdComplete1(newValue?.codigo); }}
                popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Primeiro Jogador"
                    slotProps={{
                      //   htmlInput:{
                      //     ...params.InputProps,
                      //     style: { fontSize: UtilidadeService.isMobile() ? 14 : 16 }
                      //   },
                      inputLabel: {
                        style: {
                          fontSize: UtilidadeService.isMobile() ? 13 : 16
                        }
                      }
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 3, md: 3 }} paddingBottom={2}>
              <Autocomplete
                openText="Abrir"
                closeText="Fechar"
                noOptionsText="Sem opções"
                loadingText="Carregando..."
                options={opcoesAutoCompleteJogador2}
                loading={isLoading}
                disabled={isLoading}
                value={autoCompleteSelectedOption2}
                size={UtilidadeService.isMobile() ? "small" : "medium"}
                onChange={(event, newValue) => { setSelectedIdComplete2(newValue?.codigo); }}
                popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Segundo Jogador"
                    slotProps={{
                      //   htmlInput:{
                      //     ...params.InputProps,
                      //     style: { fontSize: UtilidadeService.isMobile() ? 14 : 16 }
                      //   },
                      inputLabel: {
                        style: {
                          fontSize: UtilidadeService.isMobile() ? 13 : 16
                        }
                      }
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
              <FormControl fullWidth disabled={isLoading}>
                <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                <Select
                  variant="outlined"
                  native={false}
                  value={temporadaFiltro}
                  label="Temporadas"
                  onChange={(e) => setTemporadaFiltro(Number(e.target.value))}
                  style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}
                >
                  <MenuItem value={0}>Selecione</MenuItem>
                  {
                    lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                  }
                </Select>
              </FormControl >
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }} display={"flex"} justifyContent="flex-end">

              <Tooltip title="Exportar Time">
                <LoadingButton variant="contained"
                  onClick={(e) => handleCarregar()} color="primary"
                  style={{ cursor: "pointer", height: UtilidadeService.isMobile() ? "32px" : "48px" }}
                  endIcon={<GridSaveAltIcon />}
                  loading={isLoading}
                  loadingPosition="end"
                >
                  Carregar
                </LoadingButton >
              </Tooltip>

            </Grid>
            <Grid size={{ xs: 12 }}>
              <hr />
            </Grid>
          </Grid>
          <Grid container size={{ xs: 12, sm: 12 }}>
            {isLoading && !removeLoading && <Loading />}
          </Grid>
          {UtilidadeService.isMobile() ?
            (
              <>
                <Grid container size={{ xs: 12 }}   >
                  {dadosJogador1 !== undefined && (
                    <Grid container size={{ xs: 6 }}   >
                      <Grid container size={{ xs: 12, sm: 5 }} spacing={1} direction="row" >
                        {dadosJogador1.titulos_Liga.length > 0 && (
                          <>
                            <Grid size={{ xs: 12 }} >
                              <Grid paddingBottom={1} size={{ xs: 12 }} >
                                <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }} >TÍTULOS</Typography>
                                <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }}>LIGA</Typography>
                              </Grid>
                              <Grid container key="titulosD" size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                {dadosJogador1.titulos_Liga.length > 0 && (dadosJogador1.titulos_Liga.filter(f => f.divisao).map(div => (
                                  <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                    <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Divisão"
                                            height="25"
                                            image={imagemTrofelDivisao}
                                            key={div.codigo}
                                            sx={{ width: "15px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                              <Grid container key="titulosC" size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                {dadosJogador1.titulos_Liga.length > 0 && (dadosJogador1.titulos_Liga.filter(f => f.conferencia).map(conf => (
                                  <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }} >
                                    <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Conferência"
                                            height="28"
                                            image={imagemTrofelConferencia}
                                            key={conf.codigo}
                                            sx={{ width: "18px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                              <Grid container key="titulosL" size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                {dadosJogador1.titulos_Liga.length > 0 && (dadosJogador1.titulos_Liga.filter(f => f.liga).map(lig => (
                                  <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                    <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Liga"
                                            height="25"
                                            image={imagemTrofelLiga}
                                            key={lig.codigo}
                                            sx={{ width: "15px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                            </Grid>
                          </>)}
                        {dadosJogador1.titulos_Geral.length > 0 && (
                          <>
                            <Grid size={{ xs: 12 }} spacing={2} >
                              <Grid paddingBottom={1} size={{ xs: 12 }} spacing={2}>
                                <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }}>SITE</Typography>
                              </Grid>
                              <Grid container key="titulosD" size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                {dadosJogador1.titulos_Geral.length > 0 && (dadosJogador1.titulos_Geral.filter(f => f.divisao).map(div => (
                                  <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                    <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Divisão"
                                            height="25"
                                            image={imagemTrofelDivisao}
                                            key={div.codigo}
                                            sx={{ width: "15px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                              <Grid container key="titulosC" size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                {dadosJogador1.titulos_Geral.length > 0 && (dadosJogador1.titulos_Geral.filter(f => f.conferencia).map(conf => (
                                  <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }} >
                                    <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Conferência"
                                            height="28"
                                            image={imagemTrofelConferencia}
                                            key={conf.codigo}
                                            sx={{ width: "18px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                              <Grid container key="titulosL" size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                {dadosJogador1.titulos_Geral.length > 0 && (dadosJogador1.titulos_Geral.filter(f => f.liga).map(lig => (
                                  <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                    <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Liga"
                                            height="25"
                                            image={imagemTrofelLiga}
                                            key={lig.codigo}
                                            sx={{ width: "15px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                            </Grid>
                          </>
                        )
                        }
                      </Grid>
                    </Grid>
                  )}
                  {dadosJogador2 !== undefined && (
                    <Grid container size={{ xs: 6 }}   >
                      <Grid container size={{ xs: 12, sm: 5 }} spacing={1} direction="row" >
                        {dadosJogador2.titulos_Liga.length > 0 && (
                          <>
                            <Grid size={{ xs: 12 }} textAlign={"end"}>
                              <Grid size={{ xs: 12 }} >
                                <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }} textAlign={"end"}>TÍTULOS</Typography>
                                <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }} textAlign={"end"}>LIGA</Typography>
                              </Grid>
                              <Grid container key="titulosD" size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                {dadosJogador2.titulos_Liga.length > 0 && (dadosJogador2.titulos_Liga.filter(f => f.divisao).map(div => (
                                  <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                    <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Divisão"
                                            height="25"
                                            image={imagemTrofelDivisao}
                                            key={div.codigo}
                                            sx={{ width: "15px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                              <Grid container key="titulosC" size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                {dadosJogador2.titulos_Liga.length > 0 && (dadosJogador2.titulos_Liga.filter(f => f.conferencia).map(conf => (
                                  <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }} >
                                    <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Conferência"
                                            height="28"
                                            image={imagemTrofelConferencia}
                                            key={conf.codigo}
                                            sx={{ width: "18px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                              <Grid container key="titulosL" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                {dadosJogador2.titulos_Liga.length > 0 && (dadosJogador2.titulos_Liga.filter(f => f.liga).map(lig => (
                                  <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                    <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Liga"
                                            height="25"
                                            image={imagemTrofelLiga}
                                            key={lig.codigo}
                                            sx={{ width: "15px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                            </Grid>
                          </>
                        )}
                        {dadosJogador2.titulos_Geral.length > 0 && (
                          <>
                            <Grid size={{ xs: 12 }} spacing={2} >
                              <Grid size={{ xs: 12 }} spacing={2}>
                                <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }} textAlign={"end"}>SITE</Typography>
                              </Grid>
                              <Grid container key="titulosD" size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                {dadosJogador2.titulos_Geral.length > 0 && (dadosJogador2.titulos_Geral.filter(f => f.divisao).map(div => (
                                  <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                    <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Divisão"
                                            height="25"
                                            image={imagemTrofelDivisao}
                                            key={div.codigo}
                                            sx={{ width: "15px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                              <Grid container key="titulosC" size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                {dadosJogador2.titulos_Geral.length > 0 && (dadosJogador2.titulos_Geral.filter(f => f.conferencia).map(conf => (
                                  <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }} >
                                    <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Conferência"
                                            height="28"
                                            image={imagemTrofelConferencia}
                                            key={conf.codigo}
                                            sx={{ width: "18px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                              <Grid container key="titulosL" size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                {dadosJogador2.titulos_Geral.length > 0 && (dadosJogador2.titulos_Geral.filter(f => f.liga).map(lig => (
                                  <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                    <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                      <CardActionArea>
                                        <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                          <CardMedia
                                            component="img"
                                            alt="Liga"
                                            height="25"
                                            image={imagemTrofelLiga}
                                            key={lig.codigo}
                                            sx={{ width: "15px" }}
                                          />
                                        </Tooltip>
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )))
                                }
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Grid>
                  )}
                </Grid>

                <Grid container size={{ xs: 12 }} display={"flex"} justifyContent={"center"} alignSelf={"top"}>
                  <Grid container size={{ xs: 5 }}>
                    {dadosJogador1 !== undefined && (
                      <Grid container size={{ xs: 12 }}>
                        <Grid container size={{ xs: 3 }} direction={"row"}>
                          <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, paddingRight: "10px" }}>
                            <img alt={dadosJogador1.nome_Franquia_NBA} src={dadosJogador1.logo_Franquia_NBA !== null ? dadosJogador1.logo_Franquia_NBA : semImagemFranquia} width={40} height={40} />
                          </Typography>
                          <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, paddingRight: "10px" }}>
                            <img alt={dadosJogador1.nome_Franquia} src={dadosJogador1.logo_Franquia !== null ? dadosJogador1.logo_Franquia : semImagemFranquia} width={37} height={37} />
                          </Typography>
                        </Grid>
                        <Grid container size={{ xs: 9 }} direction={"row"} display={"flow"} justifyContent={"center"} textAlign={"center"}>
                          <Grid size={{ xs: 12 }} >
                            <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, paddingRight: "10px" }}>
                              <img alt={dadosJogador1.nome} src={dadosJogador1.foto !== null && dadosJogador1.foto !== "" ? dadosJogador1.foto : semImagem} width={50} height={50} />
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 12 }} >
                            <Typography style={{ fontSize: UtilidadeService.isMobile() ? 12 : 22, paddingRight: "10px", fontWeight: "bold" }}>
                              {dadosJogador1.nome}
                            </Typography>
                            <Typography style={{ fontSize: UtilidadeService.isMobile() ? 11 : 16, paddingRight: "10px" }}>
                              {`${dadosJogador1.posicao_1}  ${dadosJogador1.posicao_2 !== null ? " - " + dadosJogador1.posicao_2 : ""} ${dadosJogador1.posicao_3 !== null ? "-" + dadosJogador1.posicao_3 : ""}  ${dadosJogador1.codigo_Franquia_NBA === 0 ? "" : " / " + dadosJogador1.nome_Franquia_NBA}`}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                  <Grid container size={{ xs: 2 }} display={"flex"} justifyContent={"center"} alignSelf={"top"} paddingTop={6} >
                    {dadosJogador1 !== undefined && (
                      <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, paddingRight: "10px" }}>
                        <img alt={"versus"} src={versusImg} width={40} height={40} />
                      </Typography>
                    )}
                  </Grid>
                  <Grid container size={{ xs: 5 }}  >
                    {dadosJogador2 !== undefined && (
                      <Grid container size={{ xs: 12 }}>
                        <Grid container size={{ xs: 9 }} direction={"row"} display={"flow"} justifyContent={"center"} textAlign={"center"}>
                          <Grid size={{ xs: 12 }}>
                            <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, paddingRight: "10px" }}>
                              <img alt={dadosJogador2.nome} src={dadosJogador2.foto !== null && dadosJogador2.foto !== "" ? dadosJogador2.foto : semImagem} width={50} height={50} />
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 12 }}>
                            <Typography style={{ fontSize: UtilidadeService.isMobile() ? 12 : 22, paddingRight: "10px", fontWeight: "bold" }}>
                              {dadosJogador2.nome}
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 12 }}>
                            <Typography style={{ fontSize: UtilidadeService.isMobile() ? 11 : 16, paddingRight: "10px" }}>
                              {`${dadosJogador2.posicao_1}  ${dadosJogador2.posicao_2 !== null ? " - " + dadosJogador2.posicao_2 : ""} ${dadosJogador2.posicao_3 !== null ? " - " + dadosJogador2.posicao_3 : ""} ${dadosJogador2.codigo_Franquia_NBA === 0 ? "" : " / " + dadosJogador2.nome_Franquia_NBA}`}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container size={{ xs: 3 }} direction={"row"}>
                          <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, paddingRight: "10px" }}>
                            <img alt={dadosJogador2.nome_Franquia_NBA} src={dadosJogador2.logo_Franquia_NBA !== null ? dadosJogador2.logo_Franquia_NBA : semImagemFranquia} width={40} height={40} />
                          </Typography>
                          <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, paddingRight: "10px" }}>
                            <img alt={dadosJogador2.nome_Franquia} src={dadosJogador2.logo_Franquia !== null ? dadosJogador2.logo_Franquia : semImagemFranquia} width={37} height={37} />
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid container size={{ xs: 12 }}>
                  <Grid container size={{ xs: 6 }} >
                    {dadosJogador1 !== undefined && dadosJogador2 !== undefined && (
                      <GraficoBarrasHorizontalRight dados1={dadosJogador1} dados2={dadosJogador2} maxValor={40} />
                    )}
                  </Grid>
                  <Grid container size={{ xs: 6 }} >
                    {dadosJogador1 !== undefined && dadosJogador2 !== undefined && (
                      <GraficoBarrasHorizontalLeft dados1={dadosJogador1} dados2={dadosJogador2} maxValor={40} />
                    )}
                  </Grid>
                </Grid>
              </>)
            :
            (
              <>
                <Grid container size={{ xs: 12 }}>
                  <Grid container size={{ xs: 12, sm: 5 }}   >
                    {dadosJogador1 !== undefined && (
                      <>
                        <Grid size={{ xs: 12 }} spacing={2}>
                          <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "5px" }}>TÍTULOS</Typography>
                        </Grid>
                        <Grid container size={{ xs: 12 }}>
                          <Grid container size={{ xs: 12, sm: 5 }} spacing={1} direction="row" height={"280px"}>
                            {dadosJogador1.titulos_Liga.length > 0 && (
                              <>
                                <Grid size={{ xs: 12 }} spacing={2} >
                                  <Grid paddingBottom={1} size={{ xs: 12 }} spacing={2}>
                                    <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }}>LIGA</Typography>
                                  </Grid>
                                  <Grid container key="titulosD" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                    {dadosJogador1.titulos_Liga.length > 0 && (dadosJogador1.titulos_Liga.filter(f => f.divisao).map(div => (
                                      <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                        <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Divisão"
                                                height="30"
                                                image={imagemTrofelDivisao}
                                                key={div.codigo}
                                                sx={{ width: "20px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                  <Grid container key="titulosC" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                    {dadosJogador1.titulos_Liga.length > 0 && (dadosJogador1.titulos_Liga.filter(f => f.conferencia).map(conf => (
                                      <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }} >
                                        <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Conferência"
                                                height="32"
                                                image={imagemTrofelConferencia}
                                                key={conf.codigo}
                                                sx={{ width: "22px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                  <Grid container key="titulosL" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                    {dadosJogador1.titulos_Liga.length > 0 && (dadosJogador1.titulos_Liga.filter(f => f.liga).map(lig => (
                                      <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                        <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Liga"
                                                height="30"
                                                image={imagemTrofelLiga}
                                                key={lig.codigo}
                                                sx={{ width: "20px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                </Grid>
                              </>)}
                            {dadosJogador1.titulos_Geral.length > 0 && (
                              <>
                                <Grid size={{ xs: 12 }} spacing={2} >
                                  <Grid paddingBottom={1} size={{ xs: 12 }} spacing={2}>
                                    <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }}>SITE</Typography>
                                  </Grid>
                                  <Grid container key="titulosD" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                    {dadosJogador1.titulos_Geral.length > 0 && (dadosJogador1.titulos_Geral.filter(f => f.divisao).map(div => (
                                      <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                        <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Divisão"
                                                height="30"
                                                image={imagemTrofelDivisao}
                                                key={div.codigo}
                                                sx={{ width: "20px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                  <Grid container key="titulosC" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                    {dadosJogador1.titulos_Geral.length > 0 && (dadosJogador1.titulos_Geral.filter(f => f.conferencia).map(conf => (
                                      <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }} >
                                        <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Conferência"
                                                height="32"
                                                image={imagemTrofelConferencia}
                                                key={conf.codigo}
                                                sx={{ width: "22px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                  <Grid container key="titulosL" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                    {dadosJogador1.titulos_Geral.length > 0 && (dadosJogador1.titulos_Geral.filter(f => f.liga).map(lig => (
                                      <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                        <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Liga"
                                                height="30"
                                                image={imagemTrofelLiga}
                                                key={lig.codigo}
                                                sx={{ width: "20px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                </Grid>
                              </>
                            )
                            }
                          </Grid>
                          <Grid container direction={"row"} size={{ xs: 12, sm: 2 }} display={"flex"} justifyContent={"end"} alignSelf={"flex-start"} >
                            <Typography style={{ fontSize: 14, paddingRight: "5px" }}>
                              <img alt={dadosJogador1.nome_Franquia_NBA} src={dadosJogador1.logo_Franquia_NBA !== null ? dadosJogador1.logo_Franquia_NBA : semImagemFranquia} width={100} height={100} />
                            </Typography>
                            <Typography style={{ fontSize: 14, paddingRight: "5px" }}>
                              <img src={dadosJogador1.logo_Franquia !== null ? dadosJogador1.logo_Franquia : semImagemFranquia} width={90} height={90} alt={dadosJogador1.nome_Franquia} />
                            </Typography>
                          </Grid>
                          <Grid container size={{ xs: 12, sm: 5 }} direction={"row"} display={"flow"} justifyContent={"center"} textAlign={"center"}>
                            <Grid size={{ xs: 12 }} >
                              <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, paddingRight: "5px" }}>
                                <img alt={dadosJogador1.nome} src={dadosJogador1.foto !== null && dadosJogador1.foto !== "" ? dadosJogador1.foto : semImagem} width={150} height={150} />
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 12 }} >
                              <Typography style={{ fontSize: 22, paddingRight: "5px", fontWeight: "bold" }}>
                                {dadosJogador1.nome}
                              </Typography>
                              <Typography style={{ fontSize: 16, paddingRight: "5px" }}>
                                {`${dadosJogador1.posicao_1}  ${dadosJogador1.posicao_2 !== null ? " - " + dadosJogador1.posicao_2 : ""} ${dadosJogador1.posicao_3 !== null ? "-" + dadosJogador1.posicao_3 : ""}  ${dadosJogador1.codigo_Franquia_NBA === 0 ? "" : " / " + dadosJogador1.nome_Franquia_NBA}`}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                  <Grid container size={{ xs: 12, sm: 2 }} display={"flex"} justifyContent={"center"} alignSelf={"top"} paddingTop={6} >
                    {dadosJogador1 !== undefined && (
                      <Typography style={{ fontSize: 14, paddingRight: "5px" }}>
                        <img src={versusImg} width={100} height={100} />
                      </Typography>
                    )}
                  </Grid>
                  <Grid container size={{ xs: 12, sm: 5 }}  >
                    {dadosJogador2 !== undefined && (
                      <>
                        <Grid size={{ xs: 12 }} spacing={2}>
                          <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }} textAlign={"end"}>TÍTULOS</Typography>
                        </Grid>
                        <Grid container size={{ xs: 12 }}>
                          <Grid container size={{ xs: 12, sm: 5 }} direction={"row"} display={"flow"} justifyContent={"center"} textAlign={"center"}>
                            <Grid size={{ xs: 12 }}>
                              <Typography style={{ fontSize: 14, paddingRight: "5px" }}>
                                <img alt={dadosJogador2.nome} src={dadosJogador2.foto !== null && dadosJogador2.foto !== "" ? dadosJogador2.foto : semImagem} width={150} height={150} />
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                              <Typography style={{ fontSize: 22, paddingRight: "5px", fontWeight: "bold" }}>
                                {dadosJogador2.nome}
                              </Typography>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                              <Typography style={{ fontSize: 16, paddingRight: "5px" }}>
                                {`${dadosJogador2.posicao_1}  ${dadosJogador2.posicao_2 !== null ? " - " + dadosJogador2.posicao_2 : ""} ${dadosJogador2.posicao_3 !== null ? " - " + dadosJogador2.posicao_3 : ""} ${dadosJogador2.codigo_Franquia_NBA === 0 ? "" : " / " + dadosJogador2.nome_Franquia_NBA}`}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid size={{ xs: 12, sm: 2 }} container direction={"row"} alignSelf={"flex-start"}>
                            <Typography style={{ fontSize: 14, paddingRight: "5px" }}>
                              <img alt={dadosJogador2.nome_Franquia_NBA} src={dadosJogador2.logo_Franquia_NBA !== null ? dadosJogador2.logo_Franquia_NBA : semImagemFranquia} width={100} />
                            </Typography>
                            <Typography style={{ fontSize: 14, paddingRight: "5px" }}>
                              <img src={dadosJogador2.logo_Franquia !== null ? dadosJogador2.logo_Franquia : semImagemFranquia} width={90} height={90} alt={dadosJogador2.nome_Franquia} />
                            </Typography>
                          </Grid>
                          <Grid container size={{ xs: 12, sm: 5 }} spacing={1} direction="row" height={"280px"}>
                            {dadosJogador2.titulos_Liga.length > 0 && (
                              <>
                                <Grid size={{ xs: 12 }} spacing={2} textAlign={"end"}>
                                  <Grid size={{ xs: 12 }} spacing={2}>
                                    <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }} textAlign={"end"}>LIGA</Typography>
                                  </Grid>
                                  <Grid container key="titulosD" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                    {dadosJogador2.titulos_Liga.length > 0 && (dadosJogador2.titulos_Liga.filter(f => f.divisao).map(div => (
                                      <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                        <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Divisão"
                                                height="35"
                                                image={imagemTrofelDivisao}
                                                key={div.codigo}
                                                sx={{ width: "25px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                  <Grid container key="titulosC" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                    {dadosJogador2.titulos_Liga.length > 0 && (dadosJogador2.titulos_Liga.filter(f => f.conferencia).map(conf => (
                                      <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }} >
                                        <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Conferência"
                                                height="35"
                                                image={imagemTrofelConferencia}
                                                key={conf.codigo}
                                                sx={{ width: "25px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                  <Grid container key="titulosL" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                    {dadosJogador2.titulos_Liga.length > 0 && (dadosJogador2.titulos_Liga.filter(f => f.liga).map(lig => (
                                      <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                        <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Liga"
                                                height="35"
                                                image={imagemTrofelLiga}
                                                key={lig.codigo}
                                                sx={{ width: "25px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                </Grid>
                              </>
                            )}
                            {dadosJogador2.titulos_Geral.length > 0 && (
                              <>
                                <Grid size={{ xs: 12 }} spacing={2} >
                                  <Grid size={{ xs: 12 }} spacing={2}>
                                    <Typography style={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: "10px" }} textAlign={"end"}>SITE</Typography>
                                  </Grid>
                                  <Grid container key="titulosD" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                    {dadosJogador2.titulos_Geral.length > 0 && (dadosJogador2.titulos_Geral.filter(f => f.divisao).map(div => (
                                      <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                        <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Divisão"
                                                height="35"
                                                image={imagemTrofelDivisao}
                                                key={div.codigo}
                                                sx={{ width: "25px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                  <Grid container key="titulosC" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                    {dadosJogador2.titulos_Geral.length > 0 && (dadosJogador2.titulos_Geral.filter(f => f.conferencia).map(conf => (
                                      <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }} >
                                        <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Conferência"
                                                height="35"
                                                image={imagemTrofelConferencia}
                                                key={conf.codigo}
                                                sx={{ width: "25px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                  <Grid container key="titulosL" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyContent="end" style={{ maxWidth: "100%" }}>
                                    {dadosJogador2.titulos_Geral.length > 0 && (dadosJogador2.titulos_Geral.filter(f => f.liga).map(lig => (
                                      <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", minWidth: "15%", marginRight: "4px" }}>
                                        <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                          <CardActionArea>
                                            <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                              <CardMedia
                                                component="img"
                                                alt="Liga"
                                                height="35"
                                                image={imagemTrofelLiga}
                                                key={lig.codigo}
                                                sx={{ width: "25px" }}
                                              />
                                            </Tooltip>
                                          </CardActionArea>
                                        </Card>
                                      </Grid>
                                    )))
                                    }
                                  </Grid>
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
                <Grid container size={{ xs: 12, sm: 12 }}>
                  <Grid size={6} paddingRight={2}>
                    {dadosJogador1 !== undefined && dadosJogador2 !== undefined && (
                      <GraficoBarrasHorizontalRight dados1={dadosJogador1} dados2={dadosJogador2} maxValor={40} />
                    )}
                  </Grid>
                  <Grid size={6} paddingLeft={2} display={"flow"} justifyContent={"end"}>
                    {dadosJogador1 !== undefined && dadosJogador2 !== undefined && (
                      <GraficoBarrasHorizontalLeft dados1={dadosJogador1} dados2={dadosJogador2} maxValor={40} />
                    )}
                  </Grid>
                </Grid>
              </>)}
        </Grid>

      </Box>
    </LayoutBaseDePagina >
  )
}

